"use strict";
/**
 * This file has been generated
 * DO NOT EDIT, IT MAY BE OVERWRITTEN
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var abstract_service_1 = require("../abstract-service");
var BundleService = /** @class */ (function (_super) {
    __extends(BundleService, _super);
    function BundleService(client, apiConfig) {
        var _this = _super.call(this, client, apiConfig) || this;
        _this.resources = {
            'create': {
                path: "/bundle/{bundleId}/create",
                methodType: "POST"
            },
            'getDataLogPeriod': {
                path: "/bundle/{bundleId}/data-log-period",
                methodType: "GET",
                returnTypeConverter: "integer_uint32"
            },
            'getName': {
                path: "/bundle/{bundleId}/name",
                methodType: "GET",
                returnTypeConverter: "string"
            },
            'getValues': {
                path: "/bundle/{bundleId}/values",
                methodType: "GET",
                returnTypeConverter: "Bytes"
            },
            'putAcl': {
                path: "/bundle/{bundleId}/acl",
                methodType: "PUT",
                bodyEncoder: "ReadWriteRights"
            },
            'putDataLogPeriod': {
                path: "/bundle/{bundleId}/data-log-period",
                methodType: "PUT",
                bodyEncoder: "integer_uint32"
            },
            'putName': {
                path: "/bundle/{bundleId}/name",
                methodType: "PUT",
                bodyEncoder: "string"
            },
        };
        return _this;
    }
    /**
    * Write variable bundle id
    * Create a bundle with id bundleId
    * LWM2M path: /1028/{bundleId}/65535
    * @tapVersion(">=1.0")
    * @param bundleId input
    * @return void api call
    */
    BundleService.prototype.create = function (bundleId) {
        var callOptions = this.createCall(bundleId);
        return this._call(callOptions);
    };
    /**
    * Write variable bundle id
    * Create a bundle with id bundleId
    * LWM2M path: /1028/{bundleId}/65535
    * @tapVersion(">=1.0")
    * @param bundleId input
    * @return call options
    */
    BundleService.prototype.createCall = function (bundleId) {
        var callOptions = this.resources.create;
        callOptions.pathParameters = {
            "bundleId": bundleId,
        };
        return callOptions;
    };
    /**
    * Get data log period
    *
    * LWM2M path: /1028/{bundleId}/2
    * @tapVersion(">=1.0")
    * @param bundleId input
    * @return number api call
    */
    BundleService.prototype.getDataLogPeriod = function (bundleId) {
        var callOptions = this.getDataLogPeriodCall(bundleId);
        return this._call(callOptions);
    };
    /**
    * Get data log period
    *
    * LWM2M path: /1028/{bundleId}/2
    * @tapVersion(">=1.0")
    * @param bundleId input
    * @return call options
    */
    BundleService.prototype.getDataLogPeriodCall = function (bundleId) {
        var callOptions = this.resources.getDataLogPeriod;
        callOptions.pathParameters = {
            "bundleId": bundleId,
        };
        return callOptions;
    };
    /**
    * Read bundle name
    *
    * LWM2M path: /1028/{bundleId}/4
    * @tapVersion(">=1.0")
    * @param bundleId input
    * @return string api call
    */
    BundleService.prototype.getName = function (bundleId) {
        var callOptions = this.getNameCall(bundleId);
        return this._call(callOptions);
    };
    /**
    * Read bundle name
    *
    * LWM2M path: /1028/{bundleId}/4
    * @tapVersion(">=1.0")
    * @param bundleId input
    * @return call options
    */
    BundleService.prototype.getNameCall = function (bundleId) {
        var callOptions = this.resources.getName;
        callOptions.pathParameters = {
            "bundleId": bundleId,
        };
        return callOptions;
    };
    /**
    * Get bundle values
    *
    * LWM2M path: /1028/{bundleId}/1
    * @tapVersion(">=1.0")
    * @param bundleId input
    * @return Uint8Array api call
    */
    BundleService.prototype.getValues = function (bundleId) {
        var callOptions = this.getValuesCall(bundleId);
        return this._call(callOptions);
    };
    /**
    * Get bundle values
    *
    * LWM2M path: /1028/{bundleId}/1
    * @tapVersion(">=1.0")
    * @param bundleId input
    * @return call options
    */
    BundleService.prototype.getValuesCall = function (bundleId) {
        var callOptions = this.resources.getValues;
        callOptions.pathParameters = {
            "bundleId": bundleId,
        };
        return callOptions;
    };
    /**
    * Write acls
    *
    * LWM2M path: /1028/{bundleId}/0
    * Body converter id: "ReadWriteRights"
    * @tapVersion(">=1.0")
    * @param bundleId input
    * @param rights input
    * @return void api call
    */
    BundleService.prototype.putAcl = function (bundleId, rights) {
        var callOptions = this.putAclCall(bundleId, rights);
        return this._call(callOptions);
    };
    /**
    * Write acls
    *
    * LWM2M path: /1028/{bundleId}/0
    * Body converter id: "ReadWriteRights"
    * @tapVersion(">=1.0")
    * @param bundleId input
    * @param rights input
    * @return call options
    */
    BundleService.prototype.putAclCall = function (bundleId, rights) {
        var callOptions = this.resources.putAcl;
        callOptions.body = rights;
        callOptions.pathParameters = {
            "bundleId": bundleId,
        };
        return callOptions;
    };
    /**
    * Write data-log period
    *
    * LWM2M path: /1028/{bundleId}/2
    * Body converter id: "integer_uint32"
    * @tapVersion(">=1.0")
    * @param bundleId input
    * @param value input
    * @return void api call
    */
    BundleService.prototype.putDataLogPeriod = function (bundleId, value) {
        var callOptions = this.putDataLogPeriodCall(bundleId, value);
        return this._call(callOptions);
    };
    /**
    * Write data-log period
    *
    * LWM2M path: /1028/{bundleId}/2
    * Body converter id: "integer_uint32"
    * @tapVersion(">=1.0")
    * @param bundleId input
    * @param value input
    * @return call options
    */
    BundleService.prototype.putDataLogPeriodCall = function (bundleId, value) {
        var callOptions = this.resources.putDataLogPeriod;
        callOptions.body = value;
        callOptions.pathParameters = {
            "bundleId": bundleId,
        };
        return callOptions;
    };
    /**
    * Write bundle name
    *
    * LWM2M path: /1028/{bundleId}/4
    * Body converter id: "string"
    * @tapVersion(">=1.0")
    * @param bundleId input
    * @param name input
    * @return void api call
    */
    BundleService.prototype.putName = function (bundleId, name) {
        var callOptions = this.putNameCall(bundleId, name);
        return this._call(callOptions);
    };
    /**
    * Write bundle name
    *
    * LWM2M path: /1028/{bundleId}/4
    * Body converter id: "string"
    * @tapVersion(">=1.0")
    * @param bundleId input
    * @param name input
    * @return call options
    */
    BundleService.prototype.putNameCall = function (bundleId, name) {
        var callOptions = this.resources.putName;
        callOptions.body = name;
        callOptions.pathParameters = {
            "bundleId": bundleId,
        };
        return callOptions;
    };
    return BundleService;
}(abstract_service_1.AbstractService));
exports.BundleService = BundleService;
